import { useQuery, UseQueryOptions } from 'react-query';
import { getApi } from '../../../config/SwaggerApi';
import { ModuleDto } from '../../../swagger';
import { configQueryReactSimpleRequestSecurity } from '../config';
const fetchModules = () =>
    getApi()
        .security.securityGetModulesGet()
        .then((response) => response.data);

const useSecurityModules = (options?: UseQueryOptions) => {
    const modulesQuery = useQuery<ModuleDto[], Error>('security-modules', fetchModules, {
        ...configQueryReactSimpleRequestSecurity,
    });

    return modulesQuery;
};

export default useSecurityModules;
